<template>
  <div class="verification-form-geo-risk">
    <div class="verification-cdd-form__questions-list">
      <h3 class="verification-cdd-form__title">
        {{ "verification-form-geo-risk.title" | globalize }}
      </h3>

      <verification-form-question
        v-model="form.qus01"
        @input="former.setAttr('geoRisk.qus01', form.qus01)"
        :question-message="
          'verification-form-geo-risk.qus-01' | globalize"
        :error-message="getFieldErrorMessage('form.qus01')"
        :disabled="isDisabled"
      >
        <a href="https://ec.europa.eu/info/business-economy-euro/banking-and-finance/financial-supervision-and-risk-management/anti-money-laundering-and-counter-terrorist-financing/eu-policy-high-risk-third-countries_en">
          {{ 'verification-form-geo-risk.lbl-link' | globalize }}
        </a>
      </verification-form-question>
    </div>
  </div>
</template>

<script>
import VerificationFormQuestion from './VerificationFormQuestion'
import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import { required } from '@validators'

import FormMixin from '@/vue/mixins/form.mixin'

export default {
  name: 'verification-form-geo-risk',
  components: { VerificationFormQuestion },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: [VerificationCDDFormer, VerificationBDDFormer],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        qus01: this.former.attrs.geoRisk.qus01,
      },
    }
  },
  validations () {
    let form = {}
    Object.keys(this.form).forEach(key => { form[key] = { required } })

    return { form }
  },
}
</script>
